import { render } from "./LangDropdown.vue?vue&type=template&id=ad866f08&scoped=true&ts=true"
import script from "./LangDropdown.vue?vue&type=script&lang=ts"
export * from "./LangDropdown.vue?vue&type=script&lang=ts"

import "./LangDropdown.vue?vue&type=style&index=0&id=ad866f08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad866f08"]])

export default __exports__